import { render, staticRenderFns } from "./AddManagement.vue?vue&type=template&id=5490e164&scoped=true&"
import script from "./AddManagement.vue?vue&type=script&lang=js&"
export * from "./AddManagement.vue?vue&type=script&lang=js&"
import style0 from "./AddManagement.vue?vue&type=style&index=0&id=5490e164&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5490e164",
  null
  
)

export default component.exports